import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { map, tap } from 'rxjs/operators';
import { ShippingService, ShippingServiceApiService } from '../../services/api/shipping-service-api.service';
import { SimuladorFreteDialogComponent } from '../simulador-frete-dialog/simulador-frete-dialog.component';

@Component({
  selector: 'mandae-shipping-service-form',
  templateUrl: './shipping-service-form.component.html',
  styleUrls: ['./shipping-service-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShippingServiceFormComponent implements OnChanges {

  @Input()
  public cep: string;

  @Input()
  public valorDeclarado: any;

  @Output()
  public selectService = new EventEmitter<ShippingService>();

  public shippingServices: ShippingService[] = [];

  public daysMapping: {[k: string]: string} = {
    '=1': '1 dia útil',
    'other': '# dias úteis',
  };

  private dimensions: any;
  private hasLoadedInitialServices = false;

  constructor(
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly shippingServiceApiService: ShippingServiceApiService,
    private readonly dialog: MatDialog,
  ) { }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.cep && changes.cep.currentValue) {
      this.initialShippingServicesLoad();
    }

    // tslint:disable-next-line:prefer-optional-chain
    if (changes.valorDeclarado && changes.valorDeclarado.currentValue) {
      this.valorDeclarado = Number(changes.valorDeclarado.currentValue.replace(/[^0-9,-]+/g, '').replace(/[.]/g, '').replace(',', '.'));
    }
  }

  public openFreightDialog() {
    const dialogRef = this.dialog.open(SimuladorFreteDialogComponent, {
      width: '900px', // Aumentado de 800px para 900px
      maxWidth: '95vw',
      minWidth: '800px', // Aumentado de 700px para 800px
      maxHeight: '70vh', // Reduzido de 95vh para 70vh
      height: 'auto',
      disableClose: true,
      autoFocus: false,
      panelClass: 'custom-dialog-container',
      data: {
        cep: this.cep
      }
    });

    // Escutar o evento de simulação diretamente da modal
    dialogRef.componentInstance.simulationComplete.subscribe((result: any) => {
      if (result && result.volumes && result.volumes.length > 0) {
        this.processSimulationData(result);
      }
    });
  }

  private processSimulationData(result: any): void {
    // Calcular dimensões médias ou usar o primeiro volume como referência
    const firstVolume = result.volumes[0];

    this.dimensions = {
      peso: firstVolume.peso || firstVolume.weight || 0.3,
      altura: firstVolume.altura || firstVolume.height || 5,
      largura: firstVolume.largura || firstVolume.width || 15,
      comprimento: firstVolume.comprimento || firstVolume.length || 20,
    };

    console.log('Processando dados da simulação no Angular:', {
      dimensions: this.dimensions,
      cep: this.cep,
      valorDeclarado: this.valorDeclarado
    });

    // Atualizar serviços de envio com as novas dimensões
    this.refreshShippingServices();
  }

  private initialShippingServicesLoad() {
    // Só carregar serviços iniciais se ainda não carregou
    if (this.hasLoadedInitialServices) {
      console.log('Serviços básicos já foram carregados, pulando...');
      return;
    }

    // Busca inicial básica (sem dimensions específicas)
    console.log('Carregando serviços básicos iniciais...');
    const basicDimensions = {
      peso: 0.3, // 300g padrão
      altura: 5,
      largura: 15,
      comprimento: 20
    };

    this.shippingServiceApiService.getOptions(
      { cep: this.cep.replace(/\D/g, ''), dimensions: basicDimensions, valorDeclarado: this.valorDeclarado || 10 })
      .pipe(
        map(response => response.opcoes),
        tap(options => {
          console.log('Serviços básicos carregados:', options);
          this.shippingServices = options;
          this.hasLoadedInitialServices = true;
          this.changeDetectorRef.markForCheck();
        }),
      )
      .subscribe();
  }

  private refreshShippingServices() {
    if (this.dimensions) {
      this.shippingServiceApiService.getOptions(
        { cep: this.cep.replace(/\D/g, ''), dimensions: this.dimensions, valorDeclarado: this.valorDeclarado })
        .pipe(
          map(response => response.opcoes),
          tap(options => {
            this.shippingServices = options;
            this.changeDetectorRef.markForCheck();
          }),
        )
        .subscribe();
    }
  }

}
